import Env from "./env";
import axios from "axios";
// import { road } from '../road.js'
import routerIndex from "../router/index";
import store from "@/store";
import { Message } from "element-ui";
// import { param } from 'jquery';

let token = "";

axios.defaults.withCredentials = false; //不带cookie
// axios.defaults.headers.common['AbioToken'] = token;
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';//配置请求头

//添加一个请求拦截器
axios.interceptors.request.use(
  function(config) {
    // if (store.state.token) {
    //   token = store.state.token;
    // }
    // config.headers.common["Authorization"] = "JWT " + token;
    config.headers.common["Authorization"] =
      "JWT " + window.localStorage.getItem("token");
    return config;
  },
  function(error) {
    // Do something with request error
    console.info(error);
    return Promise.reject(error);
  }
);

// 添加一个响应拦截器
axios.interceptors.response.use(
  function(response) {
    // store.dispatch("addtoken", response.headers["jwt-token"]);
    window.localStorage.setItem("token", response.headers["jwt-token"]);
    return response;
  },
  function(error) {
    // Do something with response error
    if (error.response.status == 401) {
      Message.error("登录过期");
      routerIndex.push("/");
    }
    return Promise.reject(error.response.data);
  }
);

//基地址
axios.defaults.baseURL = Env.baseURL;
//测试使用
export const ISDEV = Env.isDev;

//通用方法
export const POST = (url, params, baseURL) => {
  baseURL ? (axios.defaults.baseURL = "http://39.98.107.240:8088/") : "";
  return axios
    .post(url, params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    })
    .then(res => res.data);
};

export const GET = (url, params, baseURL) => {
  baseURL ? (axios.defaults.baseURL = "http://39.98.107.240:8088/") : "";
  return axios.get(url, { params: params }).then(res => res.data);
};

export const PUT = (url, params) => {
  return axios.put(url, params).then(res => res.data);
};

export const DELETE = (url, params) => {
  return axios.delete(url, { params: params }).then(res => res.data);
};

export const PATCH = (url, params) => {
  return axios.patch(url, params).then(res => res.data);
};

export const POST_xxx = (url, params) => {
  return axios.post(url, params).then(res => res.data);
};

export const GET_download = (url, params) => {
  return axios({
    method: "get",
    url: url,
    params: params,
    responseType: "arraybuffer"
  }).then(res => res.data);
};

export const GET_download1 = (url, params) => {
  return axios({
    method: "get",
    url: url,
    params: params,
    responseType: "arraybuffer"
  }).then(res => res);
};

export const POST_UPLOAD = (url, params) => {
  return axios
    .post(url, params, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/services/index.js